import useIsMobile from "../../../../../hooks/device/useIsMobile.js";
import { getTransformedPropsIfNeeded, getTransformedPropsIfNeededMobile } from "../utils/model.js";
const useSearcherFlightHotelTransformedProps = (rootProps)=>{
    const props = 'data' in rootProps ? rootProps.data : rootProps.props;
    const isMobile = useIsMobile();
    if (isMobile) {
        return getTransformedPropsIfNeededMobile(props);
    }
    return getTransformedPropsIfNeeded(props);
};
export default useSearcherFlightHotelTransformedProps;

//# sourceMappingURL=useSearcherFlightHotelTransformedProps.js.map